import { createContext, useContext } from "react";

type ThemeContextType = {
  isDarkMode: boolean;
  // The themed wrapper element, so portaled UI (popovers, menus) can mount
  // inside the theme scope instead of escaping to document.body and losing
  // the dark-mode CSS variable cascade.
  themeContainer: HTMLElement | null;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    return { isDarkMode: false, themeContainer: null };
  }
  return context;
}
